/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 *
 * You can be released from the terms, and requirements of the Academic Public
 * License by purchasing a commercial license.
 * Purchase of a commercial license is mandatory for any use of the
 * LMX Software in commercial settings.
 */
// END COPYRIGHT
// Mirrors the `IdeaSource` enum on the backend
export var IdeaSource;
(function (IdeaSource) {
    // eslint-disable-next-line no-shadow
    IdeaSource["AI"] = "AI";
    IdeaSource["HUMAN"] = "HUMAN";
})(IdeaSource || (IdeaSource = {}));
